<template>
  <div class="banner">
    <img src="../../public/202005061203225122.jpeg" alt="" style="width: 100%;height: auto;object-fit: fill">
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Banner"
}
</script>

<style scoped>

</style>